/**
 * 全站http配置
 *
 * axios参数说明
 * isToken是否需要token
 */
import axios from "axios";
import {Message} from "element-ui";
import {Base64} from "js-base64";
import NProgress from "nprogress";
import "nprogress/nprogress.css";

//默认超时时间
axios.defaults.timeout = 100000;
//返回其他状态码
axios.defaults.validateStatus = function (status) {
  return status >= 200 && status <= 500;
};
//跨域请求，允许保存cookie
axios.defaults.withCredentials = true;
// NProgress 配置
NProgress.configure({
  showSpinner: false,
});
//http request拦截
axios.interceptors.request.use(
  (config) => {
    //开启 progress bar
    NProgress.start();
    const meta = config.meta || {};
    const isToken = meta.isToken === false;
    config.headers["Authorization"] = `Basic ${Base64.encode(`saber:saber_secret`)}`;
    config.headers["tenant-id"] = config.params && config.params.tenantId;
    //让每个请求携带token
    if (sessionStorage.getItem("token") !== null && !isToken) {
      config.headers["Blade-Auth"] = "bearer " + sessionStorage.getItem("token");

      config.headers["data-auth-key"] = "/index";
    }
    //headers中配置text请求
    if (config.text === true) {
      config.headers["Content-Type"] = "text/plain";
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
//http response 拦截
axios.interceptors.response.use(
  (res) => {
    //关闭 progress bar
    NProgress.done();
    //获取状态码
    const status = res.data.code || res.status;
    const statusWhiteList = [];
    const message = res.data.msg || res.data.error_description || "未知错误";
    //如果在白名单里则自行catch逻辑处理
    if (statusWhiteList.includes(status)) return Promise.reject(res);
    // 如果请求为非200否者默认统一处理
    if (status !== 200) {
      Message({
        message: message,
        type: "error",
      });
      return Promise.reject(new Error(message));
    }
    return res;
  },
  (error) => {
    NProgress.done();
    return Promise.reject(new Error(error));
  }
);

export default axios;
